import {useEffect} from "react";
import {useSignal} from "@preact/signals-react";
import {postSubmit} from "@ui-seeker/utils";

import {BACKEND_APIS} from "@constants";
import {useToast} from "@hooks";
import { retailer } from "@signals";
import {keywordFilters, reloadKeywordsTableData} from "../../@signals";


export default function useKeywordsDrawer() {

    const { showToast } = useToast()
    const keywordFormFilters = useSignal({ ...keywordFilters.value });
    const isCreateMode = useSignal(false)
    const isAssociateMode = useSignal(false)

    const getApiUrl = () => {
        if (isCreateMode.value) return `${BACKEND_APIS.MANAGEMENT}/keywords/create`;
        if (isAssociateMode.value) return `${BACKEND_APIS.MANAGEMENT}/keywords/associate`;
        return `${BACKEND_APIS.MANAGEMENT}/keywords/update-keyword`;
    }

    const getTableTitle = () => {
        if (isCreateMode.value) return 'Create New Keyword';
        if (isAssociateMode.value) return 'Associate From Keyword';
        return 'Edit Keyword ' + keywordFormFilters.value?.keywordName;
    }

    const handleKeywordUpdate = () => {
        keywordFormFilters.value = { ...keywordFormFilters.value, siteID: retailer.value }
        showToast.promise(postSubmit(getApiUrl(), keywordFormFilters.value).then(res => {
            reloadKeywordsTableData.value = true
        }).catch(e => {
            showToast.error(e)
        }), {
            success: 'User updated successfully',
            loading: 'Updating...',
        })
    }

    useEffect(() => {
        keywordFormFilters.value = { ...keywordFilters.value };
        retailer.value = keywordFormFilters.value?.siteID ?? []
        isCreateMode.value = !!keywordFormFilters.value?.createMode
        isAssociateMode.value = !!keywordFormFilters.value?.associateMode
    }, [keywordFilters.value])

    return {
        keywordFormFilters: keywordFormFilters,
        isCreateMode: isCreateMode.value,
        isAssociateMode: isAssociateMode.value,
        handleKeywordUpdate,
        tableTile: getTableTitle()
    }
}